import CustomersEntity from '@/entities/api/customers/customer'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface AuthSlice {
	token: string | null
	customer: CustomersEntity | null
}

const initialState: AuthSlice = {
	token: null,
	customer: null,
}

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		login: (
			state,
			action: PayloadAction<{
				token: string
				customer: CustomersEntity
			}>
		) => {
			state.token = action.payload.token
			state.customer = action.payload.customer
		},
		updateUserData: (state, action: PayloadAction<{ customer: Partial<CustomersEntity> }>) => {
			state.customer = {
				...state.customer,
				...action.payload.customer,
			} as CustomersEntity
		},
		logout: (state) => {
			state.token = null
			state.customer = null
		},
	},
})

export const { login, updateUserData, logout } = authSlice.actions

export default authSlice.reducer
